// extracted by mini-css-extract-plugin
export default {"bugBountyWrap":"styles_bugBountyWrap__RsG-Y","bugBountyTitle":"styles_bugBountyTitle__LtsZe","bugBountyBody":"styles_bugBountyBody__5oF4Q"};